import { StyledTextCreator } from "apparatus/draw";
import { P, SharedColors } from "apparatus/library/common";
import { Group, Path } from "paper";
export class SimpleVoltmeter {
    constructor() {
        this.textStyler = new StyledTextCreator({
            fontFamily: "sans-serif",
            fillColor: SharedColors.stroke
        });
    }
    render(appearance) {
        const circle = new Path.Circle(P(0, 0), appearance.size / 2)
            .withStroke("default").withFill("white");
        const text = this.textStyler.create("V", P(0, appearance.size * 0.44 * 0.7), { fontSize: appearance.size * 0.7 });
        const graphic = new Group([circle, text]);
        return {
            graphic,
            hitShape: graphic.bounds.toShape(),
        };
    }
}
SimpleVoltmeter.properties = {
    label: "Voltmeter",
    defaultAppearance: {
        size: 60
    },
    appearanceSpecs: [],
};
